import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalFooter from '@/components/LegalFooter';

export default function Privacy() {
    return (
        <div className="min-h-screen bg-background flex flex-col" data-testid="privacy-page">
            <div className="pointer-events-none absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-sage/30 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-40 -right-40 w-[460px] h-[460px] rounded-full bg-dusty/40 blur-3xl" />

            <header className="relative z-10 max-w-3xl mx-auto w-full px-6 py-8">
                <Link to="/" className="inline-flex items-center gap-2 text-forest-soft hover:text-forest text-sm">
                    <ArrowLeft size={16} /> Back home
                </Link>
            </header>

            <main className="relative z-10 max-w-3xl mx-auto w-full px-6 pb-10">
                <h1 className="font-serif text-4xl text-forest mb-3">Privacy</h1>
                <p className="text-sm text-forest-soft">Last updated: February 2026</p>

                <h2 className="font-serif text-2xl text-forest mt-8">What we collect</h2>
                <p className="text-forest-soft leading-relaxed">
                    To run Quiet Mind we store: your email, name, hashed password, hashed recovery code, your onboarding preferences (focus areas, session length, reminder time, timezone), your meditation sessions, optional mood entries, optional journal entries, and a lightweight in-app event log of interactions (e.g. signup, session-completed) used to understand product usage.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">Third parties</h2>
                <ul className="text-forest-soft leading-relaxed list-disc ml-6 space-y-1">
                    <li><strong>ClickFunnels</strong> — when you sign up, we add your email to our ClickFunnels workspace and tag the contact <code>quiet-mind-signup</code> so we can send you occasional product updates and reach you about your account.</li>
                    <li><strong>Stripe</strong> — when you purchase or gift premium, Stripe processes the payment. We never see your card number.</li>
                    <li><strong>Gmail SMTP</strong> — used to deliver password-reset links, gift codes, and (optionally) reminder emails. We do not subscribe you to any newsletter.</li>
                    <li><strong>OpenAI / Anthropic (via Emergent)</strong> — when you generate an AI meditation, the prompt and your selected preferences are sent to the model provider to produce the script and audio. No additional account data leaves our servers.</li>
                </ul>

                <h2 className="font-serif text-2xl text-forest mt-8">What we don&rsquo;t do</h2>
                <ul className="text-forest-soft leading-relaxed list-disc ml-6 space-y-1">
                    <li>We do not sell your data.</li>
                    <li>We do not run ad-network trackers.</li>
                    <li>We do not read your journal entries — they are stored and only shown back to you.</li>
                </ul>

                <h2 className="font-serif text-2xl text-forest mt-8">Your rights</h2>
                <p className="text-forest-soft leading-relaxed">
                    You may export your data or delete your account at any time from your Profile. Deletion enters a 30-day soft-delete window during which signing in restores the account; afterwards it is permanently purged.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">Contact</h2>
                <p className="text-forest-soft leading-relaxed">
                    Privacy questions: <a href="mailto:support@drbrandtgibson.com" className="underline">support@drbrandtgibson.com</a>.
                </p>
            </main>

            <LegalFooter />
        </div>
    );
}
